import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { microsoftLoginWithCode } from '../../Redux/ActionCreators/authAction';

function MicrosoftCallback() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const errorParam = params.get('error');
        const source = localStorage.getItem('microsoftAuthSource') || 'login';

        if (errorParam) {
            localStorage.removeItem('microsoftAuthSource');
            navigate('/' + source, { state: { googleError: 'Microsoft sign-in was cancelled.' } });
            return;
        }

        if (!code) {
            navigate('/login', { state: { googleError: 'Microsoft sign-in failed. No code received.' } });
            return;
        }

        dispatch(microsoftLoginWithCode(code)).then((res) => {
            localStorage.removeItem('microsoftAuthSource');
            if (res?.type === 'LOGIN_USER') {
                const details = JSON.parse(localStorage.getItem('profileDetails') || '{}');
                navigate(details?.roleId === '1' ? '/users' : '/jobs');
            } else {
                const msg = res?.errorMsg ||
                    (res?.status === 409
                        ? "Email already exists. Can't proceed with Microsoft signup."
                        : 'Microsoft sign-in failed. Please try again with email and password.');
                navigate('/' + source, { state: { googleError: msg } });
            }
        });
    }, []);

    return (
        <div className="loading-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
            <div className="spinner-border" role="status" style={{ color: '#F75891', width: 48, height: 48 }}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}

export default MicrosoftCallback;
